import { clsx } from 'clsx'
import React from 'react'
import styles from '../SAPPCalendar.module.css'

interface IIconProps {
  icon: React.ReactNode
  onClick?: () => void
  className?: string
}

const Icon = ({ icon, onClick, className }: IIconProps) => {
  return (
    <div
      className={clsx(
        styles.icon,
        onClick && styles['cursor-pointer'],
        className
      )}
      onClick={onClick}
    >
      {icon}
    </div>
  )
}

export default Icon
